<div *ngIf="step == 1">
    <h6 class="montserrat-medium text-gray-500 mb-2">
        Please enter the amount paid on behalf of the client for this campaign.
    </h6>
    <div class="mat-elevation-z8">
        <div class="tableHolder table-responsive p-3 table-container-scrollable">
            <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc" class="table">
                <!-- city -->
                <ng-container matColumnDef="cityName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.cityName }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>Total</td>
                </ng-container>

                <!-- totalMFChargesSoFar -->
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Total MF charges entered so far
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{
                            element.totalChargesOfCity?.currencyCode === 'USD' ||
                            element.totalChargesOfCity?.currencyCode == 'EUR'
                                ? (element.totalChargesOfCity?.value
                                  | currency: element.totalChargesOfCity?.currencyCode)
                                : element.totalChargesOfCity?.currencyCode +
                                  ' ' +
                                  (element.totalChargesOfCity?.value | number: '1.2-2')
                        }}
                    </td>

                    <td mat-footer-cell *matFooterCellDef>
                        {{ totalCharges?.value | currency: totalCharges?.currencyCode }}
                    </td>
                </ng-container>

                <!-- additionalMFAmount -->
                <ng-container matColumnDef="additionalMFAmount">
                    <th mat-header-cell *matHeaderCellDef>Additional MF Amount *</th>
                    <td mat-cell *matCellDef="let element">
                        <input
                            type="number"
                            matInput
                            min="0"
                            cdkFocusInitial
                            (input)="editCharge(element, $event)"
                        />
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                        {{ totalAdditionalCharges | currency: totalCharges?.currencyCode }}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columns"></tr>
                <tr mat-row *matRowDef="let row; columns: columns"></tr>
                <tr mat-footer-row *matFooterRowDef="columns"></tr>
            </table>
        </div>
    </div>
    <div class="mt-2 text-gray-500 small">
        * Add the MF with your local currency
    </div>
    <div
        class="d-flex align-items-center justify-content-center"
        style="position: sticky; bottom: 0; z-index: 10; gap: 10px"
    >
        <button class="btn btn-md btn-gray-500" mat-dialog-close>cancel</button>
        <button class="btn btn-md btn-gray-500" [disabled]="isDisabled()" (click)="moveToStepTwo()">
            confirm
        </button>
    </div>
</div>
<div *ngIf="step == 2">
    <p class="mb-4">
        This amount will be debited from the client's wallet. Are you sure you want to proceed?
    </p>
    <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>cancel</button>
        <button class="btn btn-md btn-gray-500" (click)="addCharges(dataSource.data, campaignId)">
            yes
        </button>
    </div>
</div>
